import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStethoscope, faPaw, faMagic, faUser, faSitemap, faUsers, faConciergeBell } from '@fortawesome/free-solid-svg-icons'
import { useAuthServices } from '../services/useFetch'
import { Card, CardBody, Row, Col } from 'reactstrap'

const DetalleInicialCompany = () => {

    const { requestPost } = useAuthServices();

    const [dashboardData, setDashboardData] = useState({
        totalCompanys: 0,
        negocio1Count: 0,
        negocio2Count: 0,
        negocio3Count: 0,
        gestion1Count: 0,
        gestion2Count: 0,
        totalClientes: 0,
        totalServicios: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        consultaDashboardService()
    }, [])

    const consultaDashboardService = async () => {
        setLoading(true);
        const body = {}
        const response = await requestPost(body, 1);
        if (!response.error) {
            const { estado, objeto } = response.data
            if (estado && objeto) {
                setDashboardData(objeto);
            }
        }
        setLoading(false);
    }

    const configuracionSegmentos = [
        {
            id: 'NEGOCIO_1',
            titulo: 'Salud & Bienestar',
            descripcion: 'Centros médicos y especialistas',
            icono: faStethoscope,
            claseColor: 'n1',
            countKey: 'negocio1Count'
        },
        {
            id: 'NEGOCIO_2',
            titulo: 'Belleza & Estética',
            descripcion: 'Salones y centros de estética',
            icono: faMagic,
            claseColor: 'n2',
            countKey: 'negocio2Count'
        },
        {
            id: 'NEGOCIO_3',
            titulo: 'Veterinaria & Mascotas',
            descripcion: 'Clínicas y spa para mascotas',
            icono: faPaw,
            claseColor: 'n3',
            countKey: 'negocio3Count'
        }
    ];

    const configuracionGestion = [
        {
            value: 'GESTION_1',
            label: 'Profesional Independiente',
            subLabel: 'Gestionaré solo mi propia agenda.',
            icono: faUser,
            claseColor: 'g1',
            countKey: 'gestion1Count'
        },
        {
            value: 'GESTION_2',
            label: 'Institución / Empresa',
            subLabel: 'Gestionaré varias agendas para distintos profesionales.',
            icono: faSitemap,
            claseColor: 'g2',
            countKey: 'gestion2Count'
        }
    ];

    const configuracionImpacto = [
        {
            id: 'IMPACTO_1',
            label: 'Clientes finales',
            icono: faUsers,
            claseColor: 'c1',
            countKey: 'totalClientes'
        },
        {
            id: 'IMPACTO_2',
            label: 'Servicios registrados',
            icono: faConciergeBell,
            claseColor: 'c2',
            countKey: 'totalServicios'
        }
    ];

    return (
        <div className='div-container-db-agenda' >
            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                    <div className="spinner-border text-primary" role="status" style={{ color: 'orange' }}>
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                </div>
            ) : (
                <div className="dashboard-admin-container animate__animated animate__fadeIn">
                    <div className="row mt-1">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                            <div className=''>
                                <h1 className='size-db-info-agenda-h1'>
                                    Distribución por segmento de negocio:
                                </h1>
                            </div>
                        </div>
                    </div>
                    <Row className="mt-3">
                        {configuracionSegmentos.map((segmento) => (
                            <Col lg="4" md="6" className="mb-4" key={segmento.id}>
                                <Card className={`card-business-type border-0 shadow-sm h-100 card-${segmento.claseColor}`}>
                                    <CardBody className="p-4">
                                        <div className="d-flex justify-content-between mb-3">
                                            <div className={`icon-box ${segmento.claseColor}-icon`}>
                                                <FontAwesomeIcon icon={segmento.icono} />
                                            </div>
                                            <span className={`badge rounded-pill bg-${segmento.claseColor}-light text-${segmento.claseColor} px-3 py-2`}>
                                                {segmento.id}
                                            </span>
                                        </div>
                                        <h4 className="card-title-refined">{segmento.titulo}</h4>
                                        <p className="card-subtitle-refined mb-4">{segmento.descripcion}</p>
                                        <div className="d-flex align-items-baseline">
                                            <h3 className="fw-bold me-2 mb-0">{dashboardData[segmento.countKey]}</h3>
                                            <span className="text-muted small">Empresas activas</span>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <div className="total-companies-divider">
                        <div className="total-pill-elegant">
                            <span className="total-label-text">Universo Total</span>
                            <span className="total-count-number">{dashboardData.totalCompanys?.toLocaleString()} Compañías</span>
                        </div>
                    </div>
                    <div className="row mt-1">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                            <div className=''>
                                <h1 className='size-db-info-agenda-h1'>
                                    Resumen por tipo de gestión:
                                </h1>
                            </div>
                        </div>
                    </div>
                    <Row className="mt-3">
                        {configuracionGestion.map((gestion) => (
                            <Col md="6" className="mb-4" key={gestion.value}>
                                <Card className={`card-management-type border-0 shadow-sm h-100 card-${gestion.claseColor}`}>
                                    <CardBody className="p-4 d-flex align-items-center">
                                        <div className={`management-icon-box ${gestion.claseColor}-icon-bg me-4`}>
                                            <FontAwesomeIcon icon={gestion.icono} size="2x" />
                                        </div>
                                        <div className="flex-grow-1">
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div>
                                                    <h4 className="card-title-refined">{gestion.label}</h4>
                                                    <p className="card-subtitle-refined mb-0">{gestion.subLabel}</p>
                                                </div>
                                                <div className="text-end">
                                                    <h2 className="fw-bold mb-0 count-text">{dashboardData[gestion.countKey]}</h2>
                                                    <span className="text-muted smaller">Registrados</span>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <div className="row mt-1">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12" >
                            <div className=''>
                                <h1 className='size-db-info-agenda-h1'>
                                    Impacto general:
                                </h1>
                            </div>
                        </div>
                    </div>
                    <Row className="mt-3">
                        {configuracionImpacto.map((impacto) => (
                            <Col md="6" key={impacto.id}>
                                <div className={`card-impact-minimalist d-flex align-items-center p-3 mb-2 impact-bg-${impacto.claseColor}`}>
                                    <div className={`impact-icon-circle impact-icon-${impacto.claseColor} me-3`}>
                                        <FontAwesomeIcon icon={impacto.icono} />
                                    </div>
                                    <div>
                                        <h2 className="impact-number mb-0">{dashboardData[impacto.countKey]?.toLocaleString()}</h2>
                                        <span className="impact-label">{impacto.label}</span>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                    {
                        /*
                        <div className="d-flex justify-content-end mt-4">
                            <Button color="link" className="text-primary text-decoration-none fw-bold" onClick={actionGestionCliente}>
                                Gestionar listado detallado <FontAwesomeIcon icon={faChartLine} className="ms-2" />
                            </Button>
                        </div>
                        */
                    }
                </div>
            )}
        </div>
    )
}

export default DetalleInicialCompany